export const GET_INVOICES = 'GET_INVOICES';
export const GET_ALL_INVOICES = 'GET_ALL_INVOICES';
export const SET_INVOICES = 'SET_INVOICES';
export const DOWNLOAD_INVOICE = 'DOWNLOAD_INVOICE';
